import { render, staticRenderFns } from "./LeadsTable.vue?vue&type=template&id=5b121cb3&scoped=true"
import script from "./LeadsTable.vue?vue&type=script&lang=js"
export * from "./LeadsTable.vue?vue&type=script&lang=js"
import style0 from "./LeadsTable.vue?vue&type=style&index=0&id=5b121cb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b121cb3",
  null
  
)

export default component.exports